// Copyright (c) Ping. All rights reserved.
//
// Lets any surface (e.g. the Help & About settings pane) re-trigger a tour
// the user has already seen, without clearing the persisted "seen" flag. A
// per-tour nonce bumps on each replay request; the tour's runner watches it
// and force-starts a fresh run.

import { create } from 'zustand';

import type { TourId } from './tourIds';

interface TourReplayState {
  readonly nonces: Readonly<Record<string, number>>;
  /** Ask the given tour to run again now. */
  replay(tourId: TourId): void;
}

export const useTourReplay = create<TourReplayState>((set) => ({
  nonces: {},
  replay: (tourId) =>
    set((state) => ({
      nonces: { ...state.nonces, [tourId]: (state.nonces[tourId] ?? 0) + 1 },
    })),
}));
